<template>
  <LegalDocView type="withdrawal" :title="$t('shop.withdrawal_policy', 'Widerrufsrecht')">
    <!-- Built-in fallback, shown when no withdrawal text is maintained in the
         admin. Texts under legal.withdrawal.*; DE is the source, the statutory
         parts in EN/ES follow the EU model withdrawal wording. -->
    <section>
      <h2 class="font-heading text-xl font-bold text-white mb-3">{{ $t('legal.withdrawal.h_notice') }}</h2>
      <p>{{ $t('legal.withdrawal.intro') }}</p>
    </section>

    <section>
      <h3 class="font-heading text-lg font-bold text-white mb-2">{{ $t('legal.withdrawal.h_right') }}</h3>
      <p>{{ $t('legal.withdrawal.right') }}</p>
      <i18n-t keypath="legal.withdrawal.exercise" tag="p" scope="global" class="mt-3">
        <template #imprint><NuxtLink :to="localePath('/imprint')" class="text-primary hover:underline">{{ $t('imprint.title') }}</NuxtLink></template>
      </i18n-t>
    </section>

    <section>
      <h3 class="font-heading text-lg font-bold text-white mb-2">{{ $t('legal.withdrawal.h_effects') }}</h3>
      <p>{{ $t('legal.withdrawal.effects') }}</p>
    </section>

    <section>
      <h3 class="font-heading text-lg font-bold text-white mb-2">{{ $t('legal.withdrawal.h_personalized') }}</h3>
      <i18n-t keypath="legal.withdrawal.personalized" tag="p" scope="global">
        <template #orders><NuxtLink :to="localePath('/orders')" class="text-primary hover:underline">{{ $t('shop.my_orders') }}</NuxtLink></template>
      </i18n-t>
    </section>

    <section>
      <h3 class="font-heading text-lg font-bold text-white mb-2">{{ $t('legal.withdrawal.h_defects') }}</h3>
      <p>{{ $t('legal.withdrawal.defects') }}</p>
    </section>
  </LegalDocView>
</template>

<script setup>
import LegalDocView from '~/components/Legal/LegalDocView.vue'

definePageMeta({ layout: 'shop' })
const { t } = useI18n()
const localePath = useLocalePath()
useSeoMeta({
  title: () => t('shop.withdrawal_policy'),
  description: () => t('legal.withdrawal.meta_desc')
})
</script>
